import type { PageContext } from 'vike/types';

export default (pageContext: PageContext) => {
    return pageContext.locale || pageContext.defaultLocale;
};
